import { setPageTitle } from 'actions/header';
import { clearFormTemplate, getFormTemplate, updateFormTemplate, softDeleteFormTemplate } from 'actions/templates';
import Redirect from 'components/Redirect/Redirect';
import FormTemplate from 'containers/Forms/FormTemplate';
import PreviewFormTemplate from 'containers/FormTemplate/Display/PreviewFormTemplate';
import Modal from 'containers/Modals/Modal';
import swal from 'sweetalert2';
import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Spinner } from 'UI';
import { Block, Icon, Button } from '@haldor/ui';
import { Stack } from '@mui/material';

class SingleFormTemplatePage extends Component {

	/* Class setup */
	constructor(props) {
		super(props);

		this.state = {
			loading: true,
			modal: false,
		};
	}

	/* Lifecycle methods */
	componentDidMount = () => {
		this.props.getFormTemplate(this.props.match.params.id)
			.then(() => {
				this.props.setPageTitle(this.props.template.title);
				this.setState({ loading: false });
			});
	}

	componentWillUnmount = () => {
		this.props.clearFormTemplate();
	}

	/* Events */
	toggleModal = (reload) => {
		this.setState({ modal: !this.state.modal });

		if (reload) {
			this.props.setPageTitle(this.props.template.title);
		}
	}

	onUpdateTemplate = (status) => {
		const values = { ...this.props.template };

		const text = status === 'PUBLISHED'
			? this.props.translate('Are you sure you want to restore the form template')
			: this.props.translate('Are you sure you want to archive the form template');

		swal.fire({
			title: this.props.translate('are-you-sure'),
			text: text,
			showCancelButton: true,
			cancelButtonText: this.props.translate('Cancel'),
			confirmButtonText: this.props.translate('Yes'),
		}).then(async result => {
			if (result.value != null) {
				values.status = status;
				this.setState({ loading: true });
				await this.props.updateFormTemplate(values);
				this.setState({ loading: false });
				this.props.history.push(`/forms/template/${values.id}`);
			}
		});
	}

	onDeleteTemplate = () => {
		const values = { ...this.props.template };

		swal.fire({
			title: this.props.translate('are-you-sure'),
			text: this.props.translate('are-you-sure-you-want-to-delete') + ' ' + this.props.translate('This action cannot be undone.'),
			showCancelButton: true,
			cancelButtonText: this.props.translate('Cancel'),
			confirmButtonText: this.props.translate('Yes'),
		}).then(async result => {
			if (result.value != null) {
				this.setState({ loading: true });
				this.props.softDeleteFormTemplate(values.id).then(() => {
					this.props.history.push(`/forms/templates`);
				});
			}
		});
	}

	/* Render methods */
	render() {
		if (!this.props.services.forms) {
			return <Redirect to="/" />
		}

		if (this.state.loading) {
			return <Spinner center />
		}

		const { template, translate } = this.props;
		const archived = 'ARCHIVED';
		const published = 'PUBLISHED';
		const draft = 'DRAFT'

		return (
			<div className="single-task">
				<Modal isOpen={this.state.modal} onClose={() => this.toggleModal(false)} title={translate('edit')}>
					<FormTemplate initialValues={template} onAbort={this.toggleModal} />
				</Modal>

				<div className="single-section form left-side" style={{ paddingTop: 0 }}>
					<Block>
						<PreviewFormTemplate fields={template.fields} />
					</Block>
				</div>
				{template.status !== archived
					? <div className="single-actions right-side">
						<div className="action-section">
							<Stack
								direction="column"
								spacing={1}
								sx={{
									justifyContent: "flex-start",
									alignItems: "flex-start",
								}}
							>
								<h3>{translate('tools')}</h3>

								<Button type="secondary" onClick={this.toggleModal}>
									<Icon name="Pen_Small" />
									{translate('Edit')}
								</Button>

								{template.status !== draft
									? <Button type="secondary" onClick={() => this.onUpdateTemplate(archived)}>
										<Icon name="Pen_Small" />
										{translate('Archive')}
									</Button>
									: <Button type="secondary" onClick={this.onDeleteTemplate}>
										<Icon name="Pen_Small" />
										{translate('Delete')}
									</Button>
								}
							</Stack>
						</div>
					</div>
					: <div className="single-actions right-side">
						<div className="action-section">
							<Stack
								direction="column"
								spacing={1}
								sx={{
									justifyContent: "flex-start",
									alignItems: "flex-start",
								}}
							>
								<h3>{translate('tools')}</h3>

								<Button type="secondary" onClick={() => this.onUpdateTemplate(published)}>
									<Icon name="Pen_Small" />
									{translate('Restore')}
								</Button>
							</Stack>
						</div>
					</div>}
				<div className="clearfix"></div>
			</div>
		);
	}

}

function mapStateToProps(state) {
	return {
		services: state.Services.availableServices,
		translate: translate(state.Languages.translations),
		template: state.Templates.formTemplate,
	};
}

export default connect(mapStateToProps, {
	updateFormTemplate,
	getFormTemplate,
	setPageTitle,
	clearFormTemplate,
	softDeleteFormTemplate,
})(SingleFormTemplatePage);
